import Auth from "@aws-amplify/auth"
import { FederatedResponse, FederatedUser, SignUpParams } from "@aws-amplify/auth/lib/types"
import { CognitoUser, ISignUpResult } from "amazon-cognito-identity-js"
import { ICredentials } from "aws-amplify/lib/Common/types/types"
import { publicEnvVars } from "../../../utils/config"

Auth.configure({
    identityPoolId: publicEnvVars.COGNITO_IDENTITY_POOL_ID,
    region: "us-east-1",
    identityPoolRegion: "us-east-1",
    userPoolId: publicEnvVars.COGNITO_USER_POOL_ID,
    userPoolWebClientId: publicEnvVars.COGNITO_CLIENT_ID,
})

export const signIn = (name: string, password: string): Promise<any> => {
    return Auth.signIn(name.toLowerCase(), password)
}

export const signUp = (params: SignUpParams): Promise<ISignUpResult> => {
    const username = params.username.toLowerCase()
    return Auth.signUp({
        ...params,
        username: username,
    })
}

export const confirmSignUp = (username: string, code: string): Promise<any> => {
    return Auth.confirmSignUp(username.toLowerCase(), code)
}

export const currentAuthenticatedUser = (): Promise<CognitoUser | any> => {
    return Auth.currentAuthenticatedUser()
}

export const forgotPassword = (username: string): Promise<any> => {
    return Auth.forgotPassword(username.toLowerCase())
}

export const forgotPasswordSubmit = (username: string, code: string, newPassword: string): Promise<void> => {
    return Auth.forgotPasswordSubmit(username.toLowerCase(), code, newPassword)
}

export const changePassword = (
    user: CognitoUser | any,
    oldPassword: string,
    newPassword: string
): Promise<"SUCCESS"> => {
    return Auth.changePassword(user, oldPassword, newPassword)
}

export const signOut = (): Promise<any> => {
    return Auth.signOut()
}

export const federatedSignIn = (
    provider: "google" | "facebook" | "amazon" | "developer" | string,
    response: FederatedResponse,
    user: FederatedUser
): Promise<ICredentials> => {
    return Auth.federatedSignIn(provider, response, user)
}
